import {
  WALLET_ROLES_SUCCESS,
  WALLET_ROLES_FAILED,
  WALLET_ROLES_INVALID_WALLET_ID,
  WALLET_ROLES_INVALID_TOKEN,
  RESET_WALLET_ROLES,
  LOADING_WALLET_ROLES,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  invalidWalletId: false,
  invalidToken: false,
  status: "",
  roleList: [],
  entityList: [],
  businessList: [],
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_WALLET_ROLES:
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        invalidWalletId: false,
        invalidToken: false,
        status: "",
        networkError: "",
      };
    case WALLET_ROLES_FAILED:
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidWalletId: false,
        invalidToken: false,
        status: action.payload.status,
        networkError: "",
      };

    case WALLET_ROLES_INVALID_TOKEN:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidWalletId: false,
        invalidToken: true,
        status: action.payload.status,
        networkError: "",
      };

    case WALLET_ROLES_INVALID_WALLET_ID:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidWalletId: true,
        invalidToken: false,
        status: action.payload.status,
        networkError: "",
      };
    case WALLET_ROLES_SUCCESS: {
      // let newData = { ...state.data };
      // console.log(action.payload.roleList);
      // newData = action.payload.roleList.map((v) => {
      //   return v.slice(0, 1).toUpperCase() + v.slice(1, v.length + 1);
      // });
      const { roleList, ...rest } = action.payload;
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidWalletId: false,
        invalidToken: false,
        roleList: roleList.map(
          (role) =>
            role.slice(0, 1).toUpperCase() + role.slice(1, role.length + 1)
        ),
        ...rest,
        networkError: "",
      };
    }

    case RESET_WALLET_ROLES:
      return (state = initialState);

    default:
      return state;
  }
};
